import Vue from 'vue';
import releaseNotesTransformer from './../../transformers/releaseNote';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const releaseNotes = releaseNotesTransformer.fetchCollection(data);
  resolve(releaseNotes);
};

const failed = () => {};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/release_notes', params))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/releaseNote/all.js